<template>
  <div class="row bg-white"
       :style="props.embedded ? 'height: 100%; display: flex; flex-direction: column;' : ''">
    <div class="col-12"
         :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">
      <div class="row gy-2"
           :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">

        <div v-if="!props.embedded" class="col-12">
          <!-- Filter bar -->
          <div class="dash-filterbar">
            <NSelect
                v-model:value="FILTERS.ELEMENT"
                @update:value="onElementChange"
                :disabled="isLoading"
                :options="ELEMENT_OPTS"
                :theme-overrides="inputTheme"
                filterable
                clearable
                placeholder="Select commodity to view"
                :input-props="{ autocomplete: Math.random() }"
                class="dash-filterbar__select"
                size="small"
            />
            <div class="input-wrapper dash-filterbar__product">
              <NSelect
                  v-model:value="FILTERS.PRODUCT"
                  :disabled="isLoading"
                  :options="PRODUCT_OPTS"
                  :theme-overrides="inputTheme"
                  filterable
                  clearable
                  placeholder="Select product to view"
                  :input-props="{ autocomplete: Math.random() }"
                  class="dash-filterbar__select"
                  size="small"
              />
              <div v-if="showToast" class="p-toast" style="position: absolute; top: 100%; left: 0; margin-top: 4px; width: max-content; max-width: 320px; z-index: 10; pointer-events: none;">
                Please select a product from the list before filtering.
                <button class="p-toast__close" aria-label="Dismiss" @click="showToast = false">&#x2715;</button>
              </div>
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">Start</span>
              <NDatePicker
                  v-model:value="yearsView[0]"
                  type="year"
                  clearable
                  :is-date-disabled="disableOutOfRange"
                  :input-props="{ autocomplete: randomId }"
                  class="dash-filterbar__datepicker"
                  size="small"
              />
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">End</span>
              <NDatePicker
                  v-model:value="yearsView[1]"
                  type="year"
                  clearable
                  :is-date-disabled="disableOutOfRange"
                  :input-props="{ autocomplete: randomId }"
                  class="dash-filterbar__datepicker"
                  size="small"
              />
            </div>
            <NButton
                size="small"
                :disabled="isDisabled"
                @click="getTableData()"
                color="#213ce5"
                style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;"
                @mouseenter="(e) => e.currentTarget.style.border = '1px solid #00aeef'"
                @mouseleave="(e) => e.currentTarget.style.border = '1px solid transparent'"
            >
              Search
            </NButton>
          </div>

          <!-- Action row -->
          <div class="dash-actions">
            <button
                class="dash-action-btn"
                :class="{ 'dash-action-btn--active': displayType === 'Table' }"
                @click="setType('Table')"
            >
              <img :src="DDICONS.table" alt="" class="dash-action-btn__icon" />
              View as table
            </button>

            <button
                class="dash-action-btn"
                :class="{ 'dash-action-btn--active': displayType === 'Graph' }"
                @click="setType('Graph')"
            >
              <img :src="DDICONS.graphic" alt="" class="dash-action-btn__icon" />
              View as Graphic
            </button>

            <button
                class="dash-action-btn"
                :class="{ 'dash-action-btn--active': displayType === 'All' }"
                @click="setType('All')"
            >
              <img :src="DDICONS.graphTable" alt="" class="dash-action-btn__icon" />
              View Table &amp; Graphic
            </button>

            <div class="relative inline-block">
              <button
                  class="dash-action-btn"
                  :disabled="!isTableViewSearchable"
                  @click="menuOpen = !menuOpen"
              >
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                {{ displayType === 'Graph' ? 'Export Graphic' : displayType === 'All' ? 'Export' : 'Export Data' }}
              </button>
              <div v-show="menuOpen" class="split-menu" role="menu">
                <template v-if="displayType !== 'Graph'">
                  <button role="menuitem" @click="handleExportExcel">Export as Excel</button>
                  <button role="menuitem" @click="handleExportCSV">Export as CSV</button>
                </template>
                <template v-if="displayType !== 'Table'">
                  <button role="menuitem" @click="exportAs('png')">Export as PNG</button>
                  <button role="menuitem" @click="exportAs('svg')">Export as SVG</button>
                </template>
              </div>
            </div>

            <span class="dash-actions__disclaimer" @click="showDisclaimer = true">
      <em>Disclaimer</em>
    </span>
          </div>
        </div>

        <div v-if="needsRefresh && !props.embedded" class="col-12">
          <div class="dash-empty-state">
            Select a commodity and product, then click&nbsp;<strong>Search</strong>&nbsp;to load data.
          </div>
        </div>

        <div v-if="!needsRefresh && !props.embedded && (displayType == 'Table' || displayType == 'All')" class="col-12">
          <div class="table-scroll modern-scrollbar">
            <NDataTable :columns="columns" :data="tableData" :row-key="rowKey" />
          </div>
        </div>

        <div v-if="(props.embedded || !needsRefresh) && (displayType == 'Graph' || displayType == 'All')" class="col-12"
             :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">
          <div v-if="!props.embedded && (displayType == 'Graph' || displayType == 'All')" class="row gy-3"
               style="margin-bottom: 8px;">
            <div class="col-4">
              <NSelect v-model:value="graphView" :options="GRAPH_VIEW_OPTIONS" placeholder="Select graph view"
                       :input-props="{ autocomplete: Math.random() }" :theme-overrides="inputTheme" />
            </div>
          </div>

          <div oncontextmenu="return false;" style="background-color: white;" ref="captureDiv"
               :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">
            <div class="col-12"
                 style="background: url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center/cover no-repeat; background-size: 60%;"
                 :style="props.embedded
                    ? 'flex: 1; min-height: 0; height: 100%; background-color: #f8f9fa;'
                    : 'background-color: rgba(255,255,255,0.8); padding: 20px;'">
              <div class="col-12"
                   style="position: relative;"
                   :style="props.embedded
                    ? 'flex: 1; min-height: 0; height: 100%; background-color: #f8f9fa;'
                    : 'background-color: rgba(255,255,255,0.8); padding: 20px;'">

                <div v-show="isChartLoading && !(props.embedded && props.locked)"
                     style="position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; background: white; z-index: 10; gap: 1.5rem;">
                  <div class="custom-loader">
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                  </div>
                  <p class="loading-text">Loading...</p>
                </div>
                <DynamicChart
                    v-show="!isChartLoading"
                    ref="dynamicChartRef"
                    :chartData="chartData"
                    :options="embeddedOptions"
                    :chart-type="graphView"
                    :height="props.embedded ? '100%' : '500px'"
                    :embedded="props.embedded"
                />
              </div>
            </div>
          </div>
        </div>
        <p v-if="!props.embedded" style="font-size: smaller;"><em>Source: Project Blue. Market data compiled by Project Blue from Project
          Blue data and multiple price reporting agencies.</em></p>
        <p v-if="!props.embedded" style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
      </div>
    </div>
  </div>

  <NDrawer v-if="!props.embedded" v-model:show="showDisclaimer" :width="400" :height="200" placement="right">
    <TermsAndConditions />
  </NDrawer>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, h, nextTick, } from "vue";
import {NSelect, NDataTable, NDatePicker, NButton, NDrawer} from "naive-ui";
import DynamicChart from "@/components/DynamicChart.vue";
import { SUBSCRIPTION_INFO } from "@/composables/subscription";
import { getMarketData, marketData, products, getCommodityProductsAndCountries } from "@/composables/marketData/datadashboards";
import * as htmlToImage from 'html-to-image';
import TermsAndConditions from "./TermsAndConditions.vue";
import { exportToCSV, exportToExcel } from "../../composables/marketData/datadashboards";
import { DDICONS } from "../../composables/generics";
import { logUserAction, USER_ACTIONS } from "@/composables/userLogs";
const randomId = ref(Math.random().toString());
const inputTheme = {
  peers: {
    InternalSelection: {
      borderHover: '1px solid #213ce5',
      borderFocus: '1px solid #213ce5',
      borderActive: '1px solid #213ce5',
      boxShadowFocus: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowActive: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowHover: 'none',
      caretColor: '#213ce5',
      arrowColorActive: '#213ce5',
      arrowColorHover: '#213ce5',
      color: '#fff',
      colorActive: '#ffffff',
      colorFocus: '#ffffff',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    },
    InternalSelectMenu: {
      optionColorActive: 'rgba(33, 60, 229, 0.08)',
      optionColorActivePending: 'rgba(33, 60, 229, 0.12)',
      optionColorPending: 'rgba(33, 60, 229, 0.05)',
      optionTextColorActive: '#213ce5',
      optionTextColorChildActive: '#213ce5',
      optionCheckColor: '#213ce5',
      actionDividerColor: '#213ce5',
      loadingColor: '#213ce5',
      scrollbarColor: 'rgba(33, 60, 229, 0.3)',
      scrollbarColorHover: 'rgba(33, 60, 229, 0.5)',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    }
  }
};
const props = defineProps({
  embedded: {
    type: Boolean,
    default: false
  },
  locked: { type: Boolean, default: false }
});
const isChartLoading = ref(false);

const handleClickOutside = (e) => {
  if (!e.target.closest('.relative.inline-block')) menuOpen.value = false
}
const finishProgress = async () => {
  await new Promise(r => setTimeout(r, 400));
  isChartLoading.value = false;
};
const ELEMENT_OPTS = computed(() => {
  return SUBSCRIPTION_INFO?.dataElements?.map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
})

const FILTERS = reactive({
  SUBSCRIPTION: null,
  ELEMENT: null,
  SUB_ELEMENT: null,
  COMPANY: null,
  COUNTRY: null,
  ASSET: null
})

const embeddedTitle = computed(() => {
  if (!ELEMENT_OPTS.value) return FILTERS.ELEMENT ?? '';
  return ELEMENT_OPTS.value.find(x => x.value === FILTERS.ELEMENT)?.label
      ?? FILTERS.ELEMENT
      ?? '';
});

const GRAPH_VIEW_OPTIONS = ref([
  { label: 'Default', value: 'bar' },
  { label: 'Mixed Chart', value: 'mixed' },
  { label: 'Line Chart', value: 'line' },
  // { label: 'Stacked Chart', value: 'line' } - TODO
])
const priceDecimals = ref(1);
const demandDecimals = ref(0);
const priceUom = ref("Price");
const supplyUom = ref("Supply");
const demandUom = ref("Demand");
const isSearch = ref(false);
const lastYearStart = ref(2015);
const lastYearEnd = ref(2035);
const showDisclaimer = ref(false);
const captureDiv = ref(null);
const showOptions = ref(false);
const isLoading = ref(true);
const displayType = ref("Table");
const selectedProduct = ref(null);
const showToast = ref(false);
const needsRefresh = ref(false);
const dynamicChartRef = ref(null);


const graphView = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const yearsView = ref([
  (new Date(2015, 0)).getTime(),
  (new Date(2035, 0)).getTime(),
]);

const updatedDate = ref(new Date())

const isTableViewSearchable = computed(() => {
  return FILTERS.ELEMENT !== null && yearsView.value?.length === 2;
});

const isDisabled = computed(() => {
  return FILTERS.PRODUCT === null || FILTERS.ELEMENT === null || yearsView.value?.length !== 2 || isLoading.value;
});
watch(
  () => FILTERS.PRODUCT,
  (newVal) => {
    if (newVal != null) {
      sessionStorage.setItem("productMarket", newVal);
    }
  }
);

const PRODUCT_OPTS = computed(() => {
  return (products.value ?? []).map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
});

const showDatePickers = ref(false);
function checkProductMatch(savedProduct) {
  const matched = products.value.find(x => x.code == savedProduct);
  if (matched) {
    FILTERS.PRODUCT = matched.code;
    showToast.value = false;
    yearsView.value = [
      new Date(matched.startYear, 0).getTime(),
      new Date(matched.endYear, 0).getTime()
    ];
  } else {
    FILTERS.PRODUCT = null;
    showToast.value = true;
    sessionStorage.removeItem("productMarket");
  }
}

onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  FILTERS.ELEMENT = sessionStorage.getItem("element") ?? ELEMENT_OPTS.value[0].value;
  const savedProduct = sessionStorage.getItem("productMarket");
  isLoading.value = false;
  displayType.value = props.embedded ? "Graph" : (localStorage.getItem("displayType") ?? "Table");
  await getCommodityProductsAndCountries(FILTERS.ELEMENT, "Market");

  checkProductMatch(savedProduct);

  watch(
    () => FILTERS.ELEMENT,
    (newVal) => {
      getCommodityProductsAndCountries(newVal, "Market");
      sessionStorage.setItem("element", newVal);
      FILTERS.COUNTRY = null;
      FILTERS.PRODUCT = null;
      showToast.value = true;
      needsRefresh.value = true;
    }
  );
  getTableData();
});
onUnmounted(() => document.removeEventListener('click', handleClickOutside))

const onElementChange = (newValue) => {
  sessionStorage.setItem("element", newValue);
  getCommodityProductsAndCountries(newValue, "Market");
  FILTERS.COUNTRY = null;
  FILTERS.PRODUCT = null;
  selectedProduct.value = null;
  marketData.value = [];
};

const minFilterYear = computed(() => {
  if (!marketData.value) return null

  const allYears = marketData?.value?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number);
    return keys;
  });

  let minAllowedYears = marketData.value.map(x => x.startYear);
  let minYear = Math.min(...minAllowedYears.filter(y => y != null));

  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min < minYear ? min : minYear;
})

const maxFilterYear = computed(() => {
  if (!marketData.value) return null

  const allYears = marketData?.value?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number)
    return keys
  })

  let maxAllowedYears = marketData.value.map(x => x.endYear)
  let maxYear = Math.max(...maxAllowedYears.filter(y => y != null))

  let max = allYears.length ? Math.max(...allYears) : null

  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear
})

const disableOutOfRange = (timestamp) => {
  const year = new Date(timestamp).getFullYear();

  if (selectedProductInfo.value) {
    return (
      year < selectedProductInfo.value.startYear ||
      year > selectedProductInfo.value.endYear
    );
  }

  return (
    year < minFilterYear.value ||
    year > maxFilterYear.value
  );
};

function setType(type) {
  displayType.value = type;
  localStorage.setItem("displayType", type);
  // Track display mode switch (Table, Graph, All)
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Switched Global Market Balance view to: "${type}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
}

const menuOpen = ref(false);

const exportAs = (type) => {
  menuOpen.value = false;
  // Track graphic download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_GRAPH,
    `Exported Global Market Balance graphic as ${type.toUpperCase()} (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
  if (type === 'svg') {
    downloadAsSvg();
  } else {
    downloadAsPng();
  }
};

const handleExportExcel = () => {
  menuOpen.value = false;
  exportToExcel(tableData.value, minYear.value, maxYear.value, 'MarketData.xlsx', 'market');
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Global Market Balance data as Excel (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const handleExportCSV = () => {
  menuOpen.value = false;
  exportToCSV(tableData.value, minYear.value, maxYear.value, 'MarketData.csv', 'market');
  // Track CSV data download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Global Market Balance data as CSV (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const downloadAsSvg = () => {
  htmlToImage.toSvg(captureDiv.value)
      .then(dataUrl => {
        const link = document.createElement("a");
        link.download = "capture.svg";
        link.href = dataUrl;
        link.click();
        showOptions.value = false;
      });
}

const downloadAsPng = () => {
  htmlToImage.toPng(captureDiv.value)
      .then(dataUrl => {
        const link = document.createElement("a");
        link.download = "capture.png";
        link.href = dataUrl;
        link.click();
        showOptions.value = false;
      });
}

const minYear = computed(() => {
  if (!marketData.value) return null

  const allYears = marketData?.value?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number);
    return keys;
  });

  let minAllowedYears = marketData.value.map(x => x.startYear);
  let minYear = Math.min(...minAllowedYears.filter(y => y != null));

  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min > minYear ? min : minYear;
})

const maxYear = computed(() => {
  if (!marketData.value) return null

  const allYears = marketData?.value?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number)
    return keys
  })

  let maxAllowedYears = marketData.value.map(x => x.endYear)
  let maxYear = Math.max(...maxAllowedYears.filter(y => y != null))

  let max = allYears.length ? Math.max(...allYears) : null

  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear
})

const columns = computed(() => {
  const start = lastYearStart.value;
  const end = lastYearEnd.value;
    
  let columnStart = minYear.value;
  let columnEnd = maxYear.value;

  if(FILTERS.PRODUCT){
    columnStart = new Date(yearsView.value[0]).getFullYear();
    columnEnd = new Date(yearsView.value[1]).getFullYear();
  }


  let data = (marketData.value || []).filter(x => x.dataType == "Price").map(x => {
    return {
      label: x.productForm, value: x.productForm
    }
  });
  const baseColumns = [
    { title: "Data Type", key: 'dataType', width: '150px', fixed: 'left' },

    // COLUMN 2 — add dropdown only when index === 2
    {
      //title: 'Product',
      title: '',
      key: 'productForm',
      width: '150px',
      fixed: 'left',
      render: (row, index) => {
        if (index === 2) {
          return h(
              NSelect,
              {
                value: selectedProduct.value ?? row.productForm,
                options: data,
                size: "small",
                style: "width: 140px",
                themeOverrides: inputTheme, // pass directly
                onUpdateValue: (v) => {
                  row.productForm = v;
                  selectedProduct.value = v;
                  getChartData()
                }
              }
          );
        }

        // normal rows
        return row.productForm;
      }
    },
    {
      title: 'Units',
      key: 'units',
      width: '100px',
      align: 'right',
      fixed: 'left',
    }
  ];

  const yearColumns = Array.from(
      { length: columnEnd - columnStart + 1 },
      (_, i) => ({
        title: `${columnStart + i}`,
        key: `${columnStart + i}`,
        width: '110px',
        align: 'right'
      })
  );

  const allColumns = [...baseColumns, ...yearColumns];

  lastYearStart.value = isSearch.value
      ? new Date(yearsView.value[0]).getFullYear()
      : lastYearStart.value;

  lastYearEnd.value = isSearch.value
      ? new Date(yearsView.value[1]).getFullYear()
      : lastYearEnd.value;

  isSearch.value = false;

  return allColumns;
});

const dataTypeUnits = reactive({
  Supply: '',
  Demand: '',
  Price: ''
})

const getYearlyData = (dataType, decimalDefault) => {
  const matchingData = (marketData.value || []).filter(nth => nth.typeName === dataType);

  const yearlyData = {};
  const start = minYear.value;
  const end = maxYear.value;
  const years = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  // Sum up yearly data across all matching entries
  years.forEach(year => {
    const total = matchingData.reduce((sum, item) => {
      const value = item?.yearlyData?.[year] || 0;
      return sum + Number(value);
    }, 0);

    // Use first matching item for decimalPlaces
    const decimalPlaces = matchingData[0]?.decimalPlaces ?? decimalDefault;

    yearlyData[year] = total.toLocaleString('en', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    });
  });

  // Attach metadata (take from first match)
  //yearlyData['productForm'] = matchingData[0]?.productForm || '';
  yearlyData['productForm'] = "";
  yearlyData['units'] = matchingData[0]?.units || '';

  dataTypeUnits[dataType] = matchingData[0]?.units || '';
  return yearlyData;
};

const getYearlyDataTotal = (dataType) => {
  const marketDataByType = (marketData.value) || [].find(nth => nth.dataType === dataType);
  const total = marketDataByType?.yearlyData ? Object.values(marketDataByType.yearlyData).reduce((acc, val) => acc + (val || 0), 0) : 0;
  return total.toFixed(2).toLocaleString('en', { maximumFractionDigits: 2 });
}

const getUoms = () => {
  let data = tableData.value;
  supplyUom.value = `Supply`;
  demandUom.value = `Demand (${data[1].units})`;
  priceUom.value = `Price (${data[2].units})`;
};

const tableData = computed(() => {
  const startYears = marketData?.value?.map(d => d.startYear) || [0];
  const endYears = marketData?.value?.map(d => d.endYear) || [0];

  let min = Math.min(...startYears);
  let max = Math.max(...endYears);

  lastYearStart.value = min == 0 ? 2015 : min;
  lastYearEnd.value = max == 0 ? 2035 : max;

  // 💡 get selected yearly data dynamically
  let selectedPriceData = (marketData.value || []).find(
    x => x.dataType === "Price" && x.productForm === selectedProduct.value
  );
  if (!selectedPriceData || selectedProduct.value == null) {
    let defaultValue = (marketData.value || []).find(
      x => x.dataType === "Price");
    selectedPriceData = defaultValue;
    selectedProduct.value = defaultValue?.productForm;
  }
  if (selectedPriceData != undefined) {

    const decimalPlaces = selectedPriceData?.decimalPlaces ?? 2;
    for (let index = new Date(yearsView.value[0]).getFullYear(); index <= new Date(yearsView.value[1]).getFullYear(); index++) {
      selectedPriceData.yearlyData[index] = !selectedPriceData?.yearlyData[index]
        ? 0
        : selectedPriceData?.yearlyData[index].toLocaleString('en', {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces
        });
    }
  };

  return [
    {
      dataType: 'Supply',
      ...getYearlyData('Supply', 0),
    },
    {
      dataType: 'Demand',
      ...getYearlyData('Demand', 0)
    },
    {
      dataType: 'Price',
      ...(selectedPriceData ? selectedPriceData.yearlyData : {}),
      units: selectedPriceData?.units || ""
    },
  ];
});


const rowKey = (row) => row.countries;

const getYearlyDataForChart = (dataType) => {
  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();
  const years = Array.from({ length: end - start + 1 }, (_, i) => start + i)
  return years.map(year => {
    const data = tableData.value.find(nth => nth.dataType === dataType);
    return data ? parseFloat((data[year] || 0).toLocaleString().replace(/,/g, '')) : 0;
  });
}

const chartData = ref({
  labels: Array.from({ length: 21 }, (_, i) => (2015 + i).toString()),
  datasets: []
})

const getChartData = () => {

  let currentType = graphView.value;
  graphView.value = null;
  setTimeout(() => {
    graphView.value = currentType ?? GRAPH_VIEW_OPTIONS.value[0].value;
  }, 30);
  getUoms();
  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();

  chartData.value.labels = Array.from({ length: end - start + 1 }, (_, i) => start + i);
  chartData.value.datasets = [
    {
      label: 'Supply',
      data: [...getYearlyDataForChart('Supply')],
      borderColor: "#213CE5",
      backgroundColor: "#213CE5",
      borderWidth: 2,
      yAxisID: 'yLeft',
      fill: false,
      type: 'line',
      order: 2
    },
    {
      label: 'Demand',
      data: [...getYearlyDataForChart('Demand')],
      borderColor: "#00AEEF",
      backgroundColor: "#00AEEF",
      borderWidth: 2,
      yAxisID: 'yLeft',
      fill: false,
      type: 'bar',
      order: 3
    },
    {
      label: 'Price',
      data: [...getYearlyDataForChart('Price')],
      borderColor: "#009A46",
      backgroundColor: "#009A46",
      borderWidth: 2,
      yAxisID: 'yRight',
      fill: false,
      type: 'line',
      order: 1
    }
  ];
};
const until = (condition) => new Promise(resolve => {
  if (condition()) return resolve();
  const stop = watch(ELEMENT_OPTS, () => {
    if (condition()) {
      stop();
      resolve();
    }
  });
});
const getTableData = async () => {
  needsRefresh.value = false;
  graphView.value = null;
  isChartLoading.value = true;

  const startYearNum = new Date(yearsView.value[0]).getFullYear();
  const endYearNum = new Date(yearsView.value[1]).getFullYear();

  // Track search query execution
  logUserAction(
    USER_ACTIONS.SEARCH_DASHBOARD,
    `Searched Global Market Balance: Commodity="${FILTERS.ELEMENT || 'N/A'}", Product="${FILTERS.PRODUCT || 'All'}", Years=${startYearNum}-${endYearNum}`
  );

  await getMarketData(FILTERS.ELEMENT, startYearNum, endYearNum, FILTERS.PRODUCT);

  if (!FILTERS.PRODUCT) {
    const start = minYear.value;
    const end = maxYear.value;

    yearsView.value = [
      (new Date((start == 'Infinity' || start == null ? 2015 : start), 0)).getTime(),
      (new Date((end == '-Infinity' || end == null ? 2035 : end), 0)).getTime(),
    ];
  }
  
  priceDecimals.value = marketData.value.find(x => x.dataType == 'Price')?.decimalPlaces ?? 1;
  demandDecimals.value = marketData.value.find(x => x.dataType == 'Demand')?.decimalPlaces ?? 0;

  getChartData();
  graphView.value = GRAPH_VIEW_OPTIONS.value[0].value;
  isSearch.value = true;

  await until(() => ELEMENT_OPTS.value?.length > 0);
  await nextTick();
  await finishProgress();
  await nextTick();
  dynamicChartRef.value?.renderChart(embeddedTitle.value);
};
// Original options ref — untouched, used for full page view
const options = ref({
  responsive: true,
  maintainAspectRatio: false,
  width: '100%',
  height: 700,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 15,
        color: 'black'
      },
      onClick: () => { return }
    }
  },
  scales: {
    x: {
      stacked: false,
      type: 'category',
      ticks: {
        color: 'black',
      },
      grid: { drawOnChartArea: false }
    },
    yLeft: {
      stacked: false,
      min: 0,
      grid: { drawOnChartArea: false },
      title: {
        display: true,
        text: `${supplyUom.value} & ${demandUom.value}`,
        font: { size: 16 },
        color: 'black'
      },
      ticks: {
        color: 'black',
        callback: (value) =>
            Number(value).toLocaleString('en-US', {
              minimumFractionDigits: demandDecimals.value,
              maximumFractionDigits: demandDecimals.value
            })
      }
    },
    yRight: {
      stacked: false,
      position: 'right',
      min: 0,
      display: true,
      grid: { drawOnChartArea: false },
      title: {
        display: true,
        text: priceUom?.value,
        font: { size: 16,weight: 500 },
        color: 'black',
      },
      ticks: {
        color: 'black',
        callback: (value) =>
            Number(value).toLocaleString('en-US', {
              minimumFractionDigits: priceDecimals.value,
              maximumFractionDigits: priceDecimals.value
            })
      }
    }
  }
});

// Embedded options — same as options but overrides maintainAspectRatio and drops fixed height
const embeddedOptions = computed(() => ({
  ...options.value,
  maintainAspectRatio: props.embedded ? false : options.value.maintainAspectRatio,
  height: props.embedded ? undefined : options.value.height,
  plugins: {
    ...options.value.plugins,
    legend: {
      ...options.value.plugins.legend,
      display: !props.locked,
    },
    title: {
      display: props.embedded && !!embeddedTitle.value && !props.locked,
      text: embeddedTitle.value,
      align: 'center',
      position: 'top',
      color: 'black',
      font: { size: 16 },
      padding: { top: 8, bottom: 4 },
    },
  },
  scales: {
    ...options.value.scales,
    x: {
      ...options.value.scales.x,
      ticks: { ...options.value.scales.x.ticks, display: !props.locked },
      title: { ...options.value.scales.x.title, display: !props.locked },
    },
    yLeft: {
      ...options.value.scales.yLeft,
      ticks: { ...options.value.scales.yLeft.ticks, display: !props.locked },
      title: { ...options.value.scales.yLeft.title, display: !props.locked },
    },
    yRight: {
      ...options.value.scales.yRight,
      ticks: { ...options.value.scales.yRight.ticks, display: !props.locked },
      title: { ...options.value.scales.yRight.title, display: !props.locked },
    },
  }
}));

watch([supplyUom, demandUom, priceUom], () => {
  options.value.scales.yLeft.title.text = `${supplyUom.value} & ${demandUom.value}`;
  options.value.scales.yRight.title.text = priceUom.value || '';
}, { immediate: true })

watch(FILTERS.ELEMENT, () => {
  //getTableData();
  yearsView.value = [
    (new Date(2015, 0)).getTime(),
    (new Date(2035, 0)).getTime(),
  ];
  showDatePickers.value = false;
}, { immediate: true })

watch(
    () => FILTERS.ELEMENT,
    (newVal) => {
      sessionStorage.setItem("element", newVal);
    }
);

watch(graphView, () => {
  if (chartData.value?.datasets?.length == 0) {
    return;
  }
  if (graphView.value == 'bar') {
    chartData.value.datasets[0].type = 'bar';
    chartData.value.datasets[1].type = 'bar';
    chartData.value.datasets[2].type = 'line';
  }
  else if (graphView.value == 'line') {
    chartData.value.datasets[0].type = 'line';
    chartData.value.datasets[1].type = 'line';
    chartData.value.datasets[2].type = 'line'
  }
  else {
    chartData.value.datasets[0].type = 'line'
    chartData.value.datasets[1].type = 'bar'
    chartData.value.datasets[2].type = 'line'
  }
  nextTick(() => dynamicChartRef.value?.renderChart(embeddedTitle.value));
});

watch(() => SUBSCRIPTION_INFO?.dataElements, async (newValue, oldValue) => {
  if (newValue?.length > 0 && oldValue?.length === 0) {
    await getTableData()
  }
}, { immediate: true });

const selectedProductInfo = computed(() =>
  products.value?.find(x => x.code === FILTERS.PRODUCT)
);
watch(
  selectedProductInfo,
  (product) => {
    if (!product) return;

    yearsView.value = [
      new Date(product.startYear, 0).getTime(),
      new Date(product.endYear, 0).getTime()
    ];
  }
);

</script>

<style lang="scss">
/* ── Filter bar ── */
.p-toast {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff8e5;
  color: #5f4b00 !important;
  border-left: 3px solid #f6c343;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px !important;
  line-height: 1.4 !important;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.p-toast__close {
  background: none;
  border: none;
  cursor: pointer;
  color: #5f4b00;
  font-size: 12px;
  line-height: 1;
  padding: 2px 4px;
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0.6;
  pointer-events: auto;
  &:hover { opacity: 1; }
}

.dash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  color: #000;
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: 'GilroyMedium', sans-serif;
  text-align: center;
  background: #f2f2f2;
}

.dash-filterbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  .n-date-picker {
    .n-input {
      --n-border: 1px solid #e0e0e6 !important;
      --n-border-hover: 1px solid #2184ff !important;
      --n-border-focus: 1px solid #2184ff !important;
      --n-border-active: 1px solid #2184ff !important;
      --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
      --n-caret-color: #2184ff !important;
    }
    .n-date-panel {
      --n-item-color-active: #2184ff !important;
      --n-item-text-color-active: #fff !important;
      --n-item-color-hover: rgba(33, 132, 255, 0.1) !important;
    }
  }

  /* Select border overrides */
  .n-base-selection {
    --n-border: 1px solid #e0e0e6 !important;
    --n-border-hover: 1px solid #2184ff !important;
    --n-border-focus: 1px solid #2184ff !important;
    --n-border-active: 1px solid #2184ff !important;
    --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
    --n-caret-color: #2184ff !important;
    --n-arrow-color-hover: #2184ff !important;
    --n-arrow-color-active: #2184ff !important;
  }
}

.dash-filterbar__select {
  width: 200px;
}
.dash-filterbar__product {
  flex: 1 1 200px;
  min-width: 120px;
  max-width: 280px;
  position: relative;
}
.dash-filterbar__date {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dash-filterbar__label {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}

.dash-filterbar__datepicker {
  width: 110px;
}

/* ── Action row ── */
.dash-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  row-gap: 0.25rem;
}

.dash-action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #000;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &--active {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:hover:not(&--active):not(:disabled) {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.dash-action-btn__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
}

.dash-actions__disclaimer {
  margin-left: auto;
  font-size: 11px;
  color: #9dabaf;
  cursor: pointer;
  &:hover { text-decoration: underline; }
}

.n-date-panel-actions__suffix>.n-button {
  display: none !important;
}

p {
  font-size: 14px !important;
  line-height: 1.625 !important;
  font-weight: 400 !important;
}

.chart-legend li {
  text-transform: none !important;
  color: red !important;
}

//.split-btn {
//  display: inline-flex;
//  border-radius: 3px;
//  overflow: hidden;
//  height: 34px;
//}

//.primary {
//  background: #00213b;
//  color: #fff;
//  border: none;
//  cursor: pointer;
//  font-size: 14px;
//}

//.toggle {
//  background: #e5e7eb;
//  border: none;
//  cursor: pointer;
//}

.caret {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid currentColor;
}

.split-menu {
  position: absolute;
  margin-top: 6px;
  background: white;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.split-menu button {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: 12px !important;
  white-space: nowrap;
}

.split-menu button:hover {
  background: rgba(37, 99, 235, 0.08);
}

//.active {
//  background-color: white !important;
//  color: #00213b !important;
//  font-weight: bold;
//  border: 1px solid #00213b !important;
//}
.v-binder-follower-content{
  width: fit-content !important;
}
.custom-loader {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 639px) {
  .dash-filterbar__select,
  .dash-filterbar__product {
    max-width: 100%;
    flex-basis: 100%;
  }

  .dash-filterbar__date {
    flex: 1 1 auto;
  }

  .dash-filterbar__datepicker {
    width: 100%;
    min-width: 80px;
  }
}
.loader-circle {
  width: 12px;
  height: 12px;
  background-color: #00213b;
  border-radius: 50%;
  animation: loader-bounce 1.4s ease-in-out infinite both;

  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }
  &:nth-child(3) { animation-delay: 0s; }
  &:nth-child(4) { animation-delay: 0.16s; }
}

@keyframes loader-bounce {
  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
  40%           { transform: scale(1); opacity: 1; }
}

.loading-text {
  color: #00213b;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  opacity: 0.8;
}

.table-scroll.modern-scrollbar {
  overflow-x: auto;
  overflow-y: visible;
  height: auto;
}
</style>